import { useMemo } from 'react';
import type { SsoService } from '../types';
import useCurrentUser from './useCurrentUser';
import { APP_OPTIONS } from '../config/constants';

export default function useCurrentAccounts(): { connectedAccounts: SsoService[] } {
  const user = useCurrentUser();
  return {
    connectedAccounts: useMemo<SsoService[]>(() => APP_OPTIONS.ssoServices.filter(
      ({ roles }: SsoService) => (user?.roles.findIndex((role) => roles.includes(role)) !== -1),
    ), [user?.roles]),
  };
}
